import React, { Fragment } from 'react';

import { localizable } from '../../../components/Localization';
import RoundInfo from '../components/RoundInfo';
import BaseStep from '../components/BaseStep';

@localizable
class CounterofferSummary extends BaseStep {
  render() {
    var {
      store: {
        acceptedOfferDetails,
        rejectedOfferDetails,
        buyerMessage,
        roundEditStore,
      },
      t,
    } = this.props;

    return (
      <Fragment>
        <h2>{t('Summary')}</h2>

        <h3>{t('Customers for the next round')}</h3>
        <ol>
          {acceptedOfferDetails &&
            acceptedOfferDetails.map(i => <li key={i.buyerId}>{this.renderBuyerName(i.item)}</li>)}
        </ol>

        <h3>{t('Customers not participating in the next round')}</h3>
        <ol>
          {rejectedOfferDetails &&
            rejectedOfferDetails.map(i => <li key={i.buyerId}>{this.renderBuyerName(i.item)}</li>)}
        </ol>

        <h3>{t('Additional information text')}</h3>

        <p>{buyerMessage || <i>{t('not entered')}</i>}</p>

        <h3>{t('Round details')}</h3>

        <RoundInfo round={roundEditStore.round} />

        <p>
          {t('Click "Finish" to start a new round')}
          <br />
          {t('This action cannot be undone.')}
        </p>
      </Fragment>
    );
  }
}

export default CounterofferSummary;



// WEBPACK FOOTER //
// ./src/app/containers/SaleWizard/Counteroffer/Summary.jsx